import { CurrencyInfo } from '@percent/admin-dashboard/api/actions/currencies/currencies.types'
import { DisbursementEnhanced } from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'

export type LogReturnedPaymentProps = {
  isOpen: boolean
  onClose: () => void
  disbursement: DisbursementEnhanced
  currencyInfo: CurrencyInfo[]
  refreshData: (() => void) | null
}

export enum LogReturnedPaymentStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
